// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3rpaI","left":"InfoRow_left__1Atvo"};